import {
  AccessLevelType,
  AppsStateUsersState,
  CONTINUOUS_DETECTION_TIME_DEFAULT,
  DeviceUserDTO,
  RoleType,
  StatusType,
  TagTypes,
  UserDevice,
  UserMobileDevice,
  UsersData,
  UsersSortType,
} from ".";
import { SortDirection } from "../types";

import {
  DeviceActionType,
  DEVICES,
  IChangeUserNearbyAlertSettingsBySocket,
} from "../../redux/devices/types";
import { HEALTH_CHECK } from "../healthCheck/types";
import { ISetUsersSettings, USERS, UsersActionType } from "./types";
const initialState: AppsStateUsersState = {
  users: {},
  mobileDeviceUser: {},
  isLoading: undefined,
  isLoadingMobileDeviceUser: undefined,
  inviteRequestSucceed: undefined,
  isEditRequestSuccess: undefined,
  settings: {
    searchValue: "",
    sort: { direction: SortDirection.ASC, type: UsersSortType.Name },
    selectedUsers: [],
    filters: {
      [RoleType.ADMIN]: false,
      [RoleType.VIEWER]: false,
      [RoleType.CAREGIVER]: false,
      [RoleType.DISPLAY]: false,
      [StatusType.ACTIVE]: false,
      [StatusType.PENDING]: false,
      [StatusType.SUSPENDED]: false,
      [AccessLevelType.ORGANIZATION]: false,
      [AccessLevelType.BLOCK]: false,
      [UserDevice.ONLINE]: false,
      [UserDevice.OFFLINE]: false,
      [UserDevice.NO_DEVICE]: false,
      [UserMobileDevice.ONLINE]: false,
      [UserMobileDevice.OFFLINE]: false,
      [UserMobileDevice.NO_DEVICE]: false,
    },
  },
};

const reducer = (
  state = initialState,
  action: UsersActionType | DeviceActionType
): AppsStateUsersState => {
  switch (action.type) {
    case HEALTH_CHECK.NEED_TO_NOTIFY_LOGIN: {
      return initialState;
    }
    case USERS.INVITE_USERS_REQUEST:
      return { ...state, isLoading: true, inviteRequestSucceed: undefined };
    case USERS.EDIT_PEMISSION_AND_STATUS_REQUEST:
    case USERS.EDIT_USER_INFO_REQUEST:
    case USERS.CHANGE_STATUS_REQUEST:
    case USERS.DELETE_USER_REQUEST:
      return { ...state, isLoading: true, isEditRequestSuccess: undefined };
    case USERS.GET_USERS_REQUEST:
      return { ...state, isLoading: true };

    case USERS.GET_USERS_SUCCESS:
      const users: UsersData = {};
      action.payload?.forEach((item) => {
        const { self, activityStatus, ...rest } = item;
        users[self.id] = {
          ...rest,
          id: self.id.toString(),
          picture: "",
        };
      });
      return { ...state, users: users, isLoading: false };

    case USERS.EDIT_USER_INFO_SUSSESS:
      const { id, activityStatus, ...rest } = action.payload;
      const editedUser = state.users[id];
      return {
        ...state,
        users: {
          ...state.users,
          [id]: {
            ...editedUser,
            ...rest,
            id,
          },
        },
        isLoading: false,
        isEditRequestSuccess: true,
      };

    case USERS.INVITE_USERS_SUSSESS:
      return { ...state, isLoading: false, inviteRequestSucceed: true };

    case USERS.DELETE_USER_SUSSESS:
    case USERS.CHANGE_STATUS_SUSSESS:
    case USERS.EDIT_PEMISSION_AND_STATUS_SUSSESS:
      return { ...state, isLoading: false, isEditRequestSuccess: true };

    case USERS.UPDATE_STATUS_BY_SOCKET: {
      const data = action.payload;
      const wasUser = state.users[data.userId];
      if (wasUser === undefined) return state;

      return {
        ...state,
        users: {
          ...state.users,
          [data.userId]: { ...wasUser, status: data.status },
        },
      };
    }

    case USERS.DELETE_BY_SOCKET: {
      const data = action.payload;
      delete state.users[data.id];
      return { ...state, users: { ...state.users } };
    }

    case USERS.INVITE_BY_SOCKET: {
      const data = action.payload;
      return { ...state, users: { ...state.users, [data.id]: data } };
    }
    case USERS.GET_PROFILE_BY_SOCKET: {
      const data = action.payload;
      const wasUser = state.users[data.userId];
      if (!wasUser) return state;
      return {
        ...state,
        users: {
          ...state.users,
          [data.userId]: {
            ...wasUser,
            firstName: data.firstName,
            lastName: data.lastName,
            status: data.status,
          },
        },
      };
    }

    case USERS.UPDATE_ACTIVITY_STATUS_BY_SOCKET: {
      const data = action.payload;
      const wasUser = state.users[data.userId];
      if (!wasUser) return state;
      return {
        ...state,
        users: {
          ...state.users,
          [data.userId]: {
            ...wasUser,

            activityStatusUpdatedOn: data.updatedOn,
          },
        },
      };
    }

    case USERS.CHANGE_STATUS_FAILURE:
    case USERS.EDIT_USER_INFO_FAILURE:
    case USERS.GET_USERS_FAILURE:
    case USERS.EDIT_PEMISSION_AND_STATUS_FAILURE:
      return { ...state, isLoading: false, isEditRequestSuccess: false };
    case USERS.SET_SETTINGS: {
      const newSettings = (action as ISetUsersSettings).payload;
      return { ...state, settings: { ...state.settings, ...newSettings } };
    }
    case USERS.CHANGE_SELECTED: {
      const selectChangeUserId = action.payload;
      const selected = [...state.settings.selectedUsers];
      if (selected.indexOf(selectChangeUserId) === -1)
        selected.push(selectChangeUserId);
      else selected.splice(selected.indexOf(selectChangeUserId), 1);
      return {
        ...state,
        settings: { ...state.settings, selectedUsers: selected },
      };
    }
    case USERS.INVITE_USERS_FAILURE:
      return { ...state, isLoading: false, inviteRequestSucceed: false };

    case USERS.GET_USERS_PICTURE_SUCCESS: {
      const data = action.payload;
      const updatedResidents = { ...state.users };
      data.map((el) => {
        if (el?.picture === null) return null;
        if (updatedResidents[el?.userId])
          updatedResidents[el?.userId] = {
            ...updatedResidents[el?.userId],
            picture: el?.picture,
          };
        return null;
      });
      if (Object.keys(updatedResidents).length > 0) {
        return {
          ...state,
          users: {
            ...updatedResidents,
          },
        };
      }
      return state;
    }
    case USERS.GET_USERS_MOBILE_DEVICES_REQUEST:
      return { ...state, isLoadingMobileDeviceUser: true };
    case USERS.GET_USERS_MOBILE_DEVICES_FAILURE:
      return { ...state, isLoadingMobileDeviceUser: false };
    case USERS.GET_USERS_MOBILE_DEVICES_SUCCESS:
      const data = action.payload;
      const mapped = {};
      data.map((el) => {
        const configs = el?.userConfigurations?.map((conf) => {
          return { ...conf, configValue: JSON.parse(conf?.configValue) };
        });
        const devices = el?.devices
          ?.filter((dev) => dev?.deviceType === TagTypes.Android)
          .map((dev) => {
            const conf = dev?.configurations?.length
              ? JSON.parse(
                  dev?.configurations?.find((el) => el?.configName === "Tag")
                    .configValue
                )
              : "";
            const continuesDetectionTime = dev?.configurations?.length
              ? conf?.ContinuousDetectionTime
              : CONTINUOUS_DETECTION_TIME_DEFAULT;
            return { ...dev, continuesDetectionTime };
          });
        mapped[el.userId] = { ...el, userConfigurations: configs, devices };
        return null;
      });
      return {
        ...state,
        mobileDeviceUser: mapped,
        isLoadingMobileDeviceUser: false,
      };
    // case USERS.USER_DEVICE_CONFIG_UPDATED: {
    //   const { userId, value } = action.payload;
    //   const was = state.mobileDeviceUser[userId];
    //   const configIndex = was.userConfigurations.findIndex(
    //     (el) => el.configName === "MobileTag"
    //   );
    //   was.userConfigurations.splice(configIndex, 1, {
    //     configName: "MobileTag",
    //     configValue: { Enable: value },
    //   });
    //   return {
    //     ...state,
    //     mobileDeviceUser: {
    //       ...state.mobileDeviceUser,
    //       [userId]: { ...was, userConfigurations: [...was.userConfigurations] },
    //     },
    //   };
    // }
    case USERS.DELETE_DEVICE_FROM_USER_BYSOCKET: {
      const data: DeviceUserDTO = action.payload;
      const user = state.mobileDeviceUser[data.id];
      if (user && user?.devices?.length) {
        const index = user?.devices?.findIndex(
          (el) =>
            el.deviceId === data.deviceId && el?.deviceType === TagTypes.Android
        );
        if (index === -1) return state;
        const copy = [...user.devices];
        copy.splice(index, 1);
        return {
          ...state,
          mobileDeviceUser: {
            ...state.mobileDeviceUser,
            [data.id]: { ...state.mobileDeviceUser[data.id], devices: copy },
          },
        };
      }
      return state;
    }
    case USERS.ADD_DEVICE_TO_USER_BY_SOCKET: {
      const data: DeviceUserDTO = action.payload;
      const user = state.mobileDeviceUser[data.id];
      if (user && data?.deviceType === TagTypes.Android) {
        const copy = [...user.devices];
        copy.push({
          deviceId: data.deviceId,
          serialNumber: data.deviceId,
          deviceType: TagTypes.Android,
          status: false,
          metadata: "",
          configurations: [],
          continuesDetectionTime: CONTINUOUS_DETECTION_TIME_DEFAULT,
        });
        return {
          ...state,
          mobileDeviceUser: {
            ...state.mobileDeviceUser,
            [data.id]: { ...state.mobileDeviceUser[data.id], devices: copy },
          },
        };
      }
      return state;
    }
    case DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_BY_SOCKET: {
      const { deviceId, continuesDetectionTime, id } = (
        action as IChangeUserNearbyAlertSettingsBySocket
      ).payload;
      const user = state.mobileDeviceUser[id];
      if (user && user?.devices?.length) {
        const index = user?.devices?.findIndex(
          (el) =>
            el.deviceId === deviceId && el?.deviceType === TagTypes.Android
        );
        if (index === -1) return state;
        const copy = [...user.devices];
        copy.splice(index, 1, {
          ...user?.devices[index],
          continuesDetectionTime,
        });
        return {
          ...state,
          mobileDeviceUser: {
            ...state.mobileDeviceUser,
            [id]: { ...state.mobileDeviceUser[id], devices: copy },
          },
        };
      }
      return state;
    }
    default:
      return state;
  }
};
export default reducer;
